<template>
  <div id="app" class :class="{'partners-bg': $route.meta.layout === 'partners'}">
    <component :is="layout">
      <router-view></router-view>
    </component>
    <portal-target name="destination"></portal-target>
    <portal-target name="modals"></portal-target>
    <changes-saved class="w-full fixed" style="bottom: 0"></changes-saved>
    <RefreshModal v-if="longSession" />
    <quarantine-modal v-if="quarantineOpen" @close="quarantineOpen = false" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import * as Cookies from 'js-cookie';
import MozInput from './helpers/input_material_like.vue';
import ChangesSaved from './views/partners/changes-saved';
import RefreshModal from './helpers/refresh-modal';
import base from '@/clients/base';
import player from '@/clients/player';
import QuarantineModal from './helpers/QuarantineModal.vue';

export default {
  components: {
    ChangesSaved,
    RefreshModal,
    QuarantineModal,
  },
  data() {
    return {
      longSession: false,
      quarantineOpen: false,
    };
  },
  created() {
    const fromCookie = Cookies.get('mozgoAuth');
    if (fromCookie && fromCookie.length) {
      this.setToken(fromCookie);
    }

    setTimeout(() => {
      this.longSession = true;
    }, 1000 * 3600);
    if (this.city_id) {
      this.initRoom(this.city_id);
    }
    this.getLastEvents();
    this.userInfo();
    console.log('GY48LS6')
  },
  computed: {
    ...mapGetters(['findApplicationById']),
    ...mapState({
      formName: state => state.form.formName,
      formEmail: state => state.form.formEmail,
      city_id: state => state.user.cityProps.id,
      user_role: state => state.auth.user.role,
      is_fetched: state => state.auth.isDataFetched,
      applications_is_fetched: state => state.applications.applicationsFetched,
      applications: state => state.applications.applications,
    }),

    layout() {
      const availableLayouts = [
        'auth',
        'default',
        'homepage',
        'partners',
        'players',
      ];
      const layout =
        availableLayouts.indexOf(this.$route.meta.layout) !== -1
          ? this.$route.meta.layout
          : 'default';
      return () =>
        import(
          /* webpackChunkName: "layouts" */ `@/layouts/${layout}-layout.vue`);
    },
  },
  methods: {
    initRoom(id) {
      window.Echo.channel(`city.${id}`)
        .listen('.event_day_closed', ({ data }) => {
          this.removeApplication(data.event_day_id);
        })
        .listen('.is_full_changed', ({ data }) => {
          this.updateApplication(data);
        })
        .listen('.event_day_created_or_updated', ({ data }) => {
          const dataApp = data[0];
          const app = this.applications.find(item => item.uuid === dataApp.uuid);
          if (!app) {
            this.addApplication(data);
          } else {
            this.updateApplication(dataApp);
          }
        })
        .listen('.registration_begun', ({ data }) => {
          const payload = data;
          if (payload.teams_id.length) {
            payload.team_ids_with_privileged_registration = data.teams;
            payload.is_privileged_registration_opened = true;
          } else {
            payload.is_registration_opened = true;
          }
          this.updateApplication(payload);
        });
    },
    leaveRoom(id) {
      window.Echo.leave(`city.${id}`);
    },
    async getLastEvents() {
      this.setApplications([]);
      this.setApplicationIsFetched(false);
      if (!this.city_id || this.applications_is_fetched) return;
      const response = await base
        .get(`/events/dates/${this.city_id}?sort=played_at`)
        .then(({ data }) => data);
      this.setApplications(response).then(() => {
        this.setApplicationIsFetched(true);
        if (!this.eventUuid && !this.game_id) return;
        if (this.user.role === 'editor' || this.user.role === 'partner' || this.user.role === 'event_organizer') {
          return;
        }
        let ref = this.$refs.pay.find(item => item.event.uuid === this.eventUuid);
        this.eventUuid = '';

        if (this.game_id || this.$route.query.gameId) {
          const gameId = this.game_id ? this.game_id : this.$route.query.gameId;
          ref = this.$refs.pay
            ? this.$refs.pay.find(item => item.event.uuid === gameId)
            : null;
          if (ref) {
            setTimeout(() => {
              ref.$refs.tryreg.click();
            }, 300);
          }
        }
      });
    },
    userInfo() {
      const route = this.city_id ? `/me?city_id=${this.city_id}` : '/me';
      if (this.is_fetched || !this.$store.state.auth.accessToken) return;
      this.setUser({});
      player.get(route).then(({ data }) => {
        if ((data.role === 'partner' || data.role === 'event_organizer') && !data.is_approved) {
          this.$emit('approve_modal');
        }
        this.setUser(data);
        this.login = false;
      });
    },
    ...mapActions([
      'selectName',
      'setFetchedData',
      'setApplicationIsFetched',
      'selectEmail',
      'setApplications',
      'updateApplication',
      'removeApplication',
      'addApplication',
      'setToken',
      'selectCityInfo',
      'setUser',
    ]),
    userLeaved() {
      this.setFetchedData(false);
      this.setApplicationIsFetched(false);
    },
    updateCityProp(city_id) {
      base.get(`/locations/cities/${city_id}`).then((response) => {
        this.selectCityInfo(response.data);
      });
    },
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.userLeaved);
  },
  mounted() {
    if (this.city_id) {
      this.updateCityProp(this.city_id);
    }
  },
  watch: {
    city_id(new_city, old_city) {
      this.setApplications([]);
      this.leaveRoom(old_city);
      this.initRoom(new_city);
      this.setApplicationIsFetched(false);
      this.getLastEvents();
    },
    user_role(n, o) {
      if (n && n.role === 'editor') {
        this.setApplicationIsFetched(false);
        this.setApplications([]);
        this.getLastEvents();
      }
    },
    '$route.query': {
      handler(val) {
        const liveTime = 1 / 8;
        if (val.utm_source) {
          Cookies.set('mozgoUtmSource', val.utm_source, { expires: liveTime });
        }
        if (val.utm_campaign) {
          Cookies.set('mozgoUtmCampaign', val.utm_campaign, { expires: liveTime });
        }
        if (val.utm_medium) {
          Cookies.set('mozgoUtmMedium', val.utm_medium, { expires: liveTime });
        }
        if (val.utm_term) {
          Cookies.set('mozgoUtmTerm', val.utm_term, { expires: liveTime });
        }
        if (val.utm_content) {
          Cookies.set('mozgoUtmContent', val.utm_content, { expires: liveTime });
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.leaveRoom(this.city_id);
  },
};
</script>

<style lang="less">
@import "./style/app";

.body-modal-open {
  overflow: hidden;
}
.hover-up {
  transition: all 0.5s;
  &:hover {
    transform: translateY(-3px);
    @apply shadow-md;
  }
}

.hover-up-text {
  transition: all 0.5s;
  &:hover {
    transform: translateY(-3px);
    text-shadow: 0 3px 1em #000000;
  }
}

.theme-brand .vdatetime-popup__header,
.theme-brand .vdatetime-calendar__month__day--selected > span > span,
.theme-brand .vdatetime-calendar__month__day--selected:hover > span > span {
  background: #bd006c;
  font-family: "Montserrat Medium";
}
.theme-brand .vdatetime-year-picker__item--selected,
.theme-brand .vdatetime-time-picker__item--selected,
.theme-brand .vdatetime-popup__actions__button {
  color: #bd006c;
  font-family: "Montserrat Medium";
}
.vdatetime-popup {
  font-family: "Montserrat Medium" !important;
}

.partners-bg {
  background-color: white;
}
.grid-center{
  display: grid;
  place-content: center;
}
.whitespace-nowrap {
  white-space: nowrap;
}
</style>
